import React from 'react';
import styled from 'styled-components';
import furhterLinkIndicator from '../assets/further-link-indicator.svg';

function createMarkup(content) {
  return {__html: `${content}`};
}

export const verticalSpace = '25px';
export const horizontalPadding = '16px';
const defaultImgVideoHeight = '315px';

const EmbeddedPostContainer = styled.div`
    width: 100%;
    display: flex;
    margin: ${verticalSpace} 0;
    justify-content: center;
    padding: 0 ${horizontalPadding};
    box-sizing: border-box;
    .twitter-tweet, .twitter-tweet-rendered {
      justify-content: center;
    }
    iframe {
      width: 100% !important;
      max-width: 535px;
    }
    iframe[id=twitter-widget-0] {
      width: 100% !important;
      max-width: 377px;
    }
`;

const EmbeddedVideoContainer = styled.div`
  width: 100%;
  margin: ${verticalSpace} 0;
  overflow: hidden;
  position: relative;
  width:100%;
  &::after {
    padding-top: 56.25%;
    display: block;
    content: '';
  }
  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

// Type:
// 1. TEXT
// - strong
// - link
// 2. IMAGE
// - caption
// 3. FURTHERLINK
// 4. EmbeddedVideo
// 5. EMVEDEDPOST
// 6. VIDEO
// 7. QUOTE
// 8. TIME

const CustomizedParagraph = styled.p`
  line-height: 160%;
  font-size: 16px;
  margin: ${verticalSpace} 0;
  padding: 0 ${horizontalPadding};
  > a {
    &:hover {
      color: ${props => props.theme.blue};
      transition: 0.3s;
      border-color: ${props => props.theme.blue} !important;
    }
    &:link {
      color: ${props => props.theme.blue};
      font-weight: bold;
      text-decoration: none;
      border-bottom: 1px solid rgb(216, 216, 216);
    }
    &:active {
      color: ${props => props.theme.blue};
      text-decoration: none;
      border-bottom: 1px solid rgb(216, 216, 216);
    }
    &:visited {
      color: ${props => props.theme.blue};
      text-decoration: none;
      border-bottom: 1px solid rgb(216, 216, 216);
    }
  }
`;


const Text = ({
  content
}) => {
  return (
    <CustomizedParagraph
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  );
}

const ImageContainer = styled.div`
  width: 100%;
  margin: ${verticalSpace} 0;
`;

const Caption = styled.div`
  padding: 8px 16px;
  color: white;
  background-color: ${props => props.theme.blue};
  font-size: 12px;
`;

const ImageWrapper = styled.div`
  width: 100%;
  > img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

const Image = ({
  url,
  caption
}) => {
  return (
    <ImageContainer>
      <ImageWrapper>
        <img
          src={url}
          alt={caption}
        />
      </ImageWrapper>
      {caption && <Caption>{`${caption}`}</Caption>}
    </ImageContainer>
  );
}

const FLA = styled.a`
  &:link {
    text-decoration: none;
    color: inherit;
  }
  &:hover {
    color: inherit;
    text-decoration: none;
  }
  &:visited {
    color: inherit;
    text-decoration: none;
  }
`;

const FutherLinkContainer = styled.div`
  background-color: #F5F5F5;
  cursor: pointer;
  position: relative;
  padding: 12px 0;
  margin: ${verticalSpace} 16px ${verticalSpace} 28px;
  &:hover {
    background-color: #E1E1E1;
  }
  img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const FurtherLinkContent = styled.div`
  padding-left: 20px;
  > div:first-child {
    color: ${props => props.theme.blue};
    margin-bottom: 4px;
  }
  > span {
    font-size: 12px;
  }
`

const FurtherLink = ({
  content,
  url,
}) => {
  return (
    <FLA
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FutherLinkContainer>
        <FurtherLinkContent>
          <div>{content}</div>
          <span>閱讀更多</span>
        </FurtherLinkContent>
        <img src={furhterLinkIndicator} alt="futher link indicating icon" />
      </FutherLinkContainer>
    </FLA>
  )
}

const Video = ({
  url,
  caption
}) => {
  return (
    <video
      width="100%"
      height={defaultImgVideoHeight}
      controls
    >
      <source src={url} type="video/mp4" />
    </video>
  );
}

const EmbeddedVideo = ({
  content,
}) => {
  return (
    <EmbeddedVideoContainer
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  );
}

const EmbeddedPost = ({
  content,
}) => {
  return (
    <EmbeddedPostContainer
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  );
}

const QuoteContainer = styled.div`
  box-sizing: border-box;
  background-color: #F5F5F5;
  border-top: 2px solid ${props => props.theme.blue};
  margin: ${verticalSpace} auto;
  max-width: 404px;
  width: 100%;
  padding: 16px ${horizontalPadding};
  display: flex;
  align-items: center;
`;

const QuoteImageWrapper = styled.div`
  height: 80px;
  flex: 0 0 80px;
  > img {
    border-radius: 50%;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  margin-right: 10px;
`;

const QuoteContent = styled.div`
  line-height: 160%;
  > div:first-child {
    font-size: 16px;
    font-weight: bold;
  }
  > div:last-child {
    font-size: 12px;
  }
`;

const Quote = ({
  content,
  url,
  who
}) => {
  return (
    <QuoteContainer>
      <QuoteImageWrapper>
        <img src={url} alt={`protrait_${who}`} />
      </QuoteImageWrapper>
      <QuoteContent>
        <div dangerouslySetInnerHTML={createMarkup(content)} />
        <div>–– {who}</div>
      </QuoteContent>
    </QuoteContainer>
  );
}

export {
  Image,
  Text,
  FurtherLink,
  EmbeddedVideo,
  EmbeddedPost,
  Quote,
  Video,
}
